import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import endashboard from "../src/locales/dashboard/en/dashboard.json";
import ardashboard from "../src/locales/dashboard/ar/dashboard.json";

import ennavbar from "../src/locales/Navbar/en/navbar.json";
import arnavbar from "../src/locales/Navbar/ar/navbar.json";

import enaddProductsHeader from "../src/locales/products/en/addProductsHeader.json";
import araddProductsHeader from "../src/locales/products/ar/addProductsHeader.json";

import ensidebar from "../src/locales/Sidebar/en/sidebar.json";
import arsidebar from "../src/locales/Sidebar/ar/sidebar.json";

import ensupplier from "../src/locales/supplier/en/addSupplier.json";
import arsupplier from "../src/locales/supplier/ar/addSupplier.json";

import enlogin from "../src/locales/login/en/login.json";
import arlogin from "../src/locales/login/ar/login.json";

import enorders from "../src/locales/orders/en/orders.json";
import arorders from "../src/locales/orders/ar/orders.json";

import enproductlist from "../src/locales/productlist/en/productlist.json";
import arproductlist from "../src/locales/productlist/ar/productlist.json";

import enprofile from "../src/locales/profile/en/profile.json";
import arprofile from "../src/locales/profile/ar/profile.json";

import enregister from "../src/locales/register/en/register.json";
import arregister from "../src/locales/register/ar/register.json";

import enreviews from "../src/locales/reviews/en/reviews.json";
import arreviews from "../src/locales/reviews/ar/reviews.json";

import ensupplierlist from "../src/locales/supplierlist/en/supplierlist.json";
import arsupplierlist from "../src/locales/supplierlist/ar/supplierlist.json";

import ennotFound from "../src/locales/notfound/en/notfound.json";
import arnotFound from "../src/locales/notfound/ar/notfound.json";

import enchat from "../src/locales/chat/en/chat.json";
import archat from "../src/locales/chat/ar/chat.json";
// /bulkproducts
import enbulkproducts from "../src/locales/bulkproducts/en.json";
import arbulkproducts from "../src/locales/bulkproducts/ar.json";

import enorganizers from "../src/locales/organizers/en/organizers.json";
import arorganizers from "../src/locales/organizers/ar/organizers.json";

const savedLanguage = localStorage.getItem("language") || "en";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        dashboard: endashboard,
        navbar: ennavbar,
        addProductsHeader: enaddProductsHeader,
        sidebar: ensidebar,
        supplier: ensupplier,
        login: enlogin,
        orders: enorders,
        productlist: enproductlist,
        profile: enprofile,
        register: enregister,
        reviews: enreviews,
        supplierlist: ensupplierlist,
        notFound: ennotFound,
        chat: enchat,
        bulkproducts: enbulkproducts,
        organizers: enorganizers,
      },
      ar: {
        dashboard: ardashboard,
        navbar: arnavbar,
        addProductsHeader: araddProductsHeader,
        sidebar: arsidebar,
        supplier: arsupplier,
        login: arlogin,
        orders: arorders,
        productlist: arproductlist,
        profile: arprofile,
        register: arregister,
        reviews: arreviews,
        supplierlist: arsupplierlist,
        notFound: arnotFound,
        chat: archat,
        bulkproducts: arbulkproducts,
        organizers: arorganizers,
      },
    },
    lng: savedLanguage,
    fallbackLng: "en",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
